import { defineStore } from "pinia";

import apolloClient from "../plugins/apollo";
import { getLives,getlive } from "@/Gql/lives.js";
export const useLivesStore = defineStore("lives", {
    state: () => {
        return {
            lives: Array,
            live: null,

        }
    },
    getters: {
        livesData: (state) => state.lives,
        getLive: (state) => state.live
    },
    actions: {
        async showLivesData() {
            await apolloClient
                .query({
                    query: getLives,
                    variables: { page: 1, limit: 6 },
                    fetchPolicy: "cache-first",
                }).then(async res => {
                    this.lives = res.data.getLives.data
                })
                .catch(error => {
                    this.error = error
                })



        },
        async showLive(liveId) {
            await apolloClient
                .query({
                    query: getlive,
                    variables: {getLiveId:liveId },
                }).then(async res => {
                    this.live = res.data.getLive
                    console.log(res.data)
                })
                .catch(error => {
                    this.error = error
                })
        }
    }
})